import React from "react";
import ReactDOM from "react-dom";
import debounce from 'lodash.debounce';

class CustomForm extends React.Component {
  init = false

  state = {
    field_value: {
      category_id: '',
      sub_category_id: '',
      city_id: '',
      area_id: '',
    },
    total_count: 0,
    categories: [],
    sub_category: [],
    cities: [],
    areas: [],
    customFields: [],
    url: new URL(window.location.href),
    searchParams: new URL(window.location.href).searchParams,
    formReset: false,
    loading: true,
  }

  constructor(props) {
    super(props);


    if (props.categoryId == 44 || props.subCategoryId == 44) {
      document.querySelector('#selectable-sorting').classList.add('hide')
      document.querySelector('#slider-price').classList.add('hide')
    } else {
      document.querySelector('#selectable-sorting').classList.remove('hide')
      document.querySelector('#slider-price').classList.remove('hide')
    }
  }

  updateSubmitButtonCount(total_count = 0) {
    let submitButton = document.querySelector('#filters-search-form button[type=submit]')
    submitButton.textContent = `نتائج البحث: ${total_count}`
  }

  resetPrices() {
    document.querySelector('[name="price_from"]').value = ''
    document.querySelector('[name="price_to"]').value = ''
  }

  resetForm() {
    this.resetPrices();

    this.setState({
      field_value: {
        category_id: '',
        sub_category_id: '',
        city_id: '',
        area_id: '',
      },
      total_count: 0,
      categories: [],
      sub_category: [],
      cities: [],
      areas: [],
      customFields: [],
      url: new URL(window.location.href),
      searchParams: new URL(window.location.href).searchParams,
      formReset: true
    })

    const _this = this;

    setTimeout(() => {
      const url = _this.buildUrl()
      _this.updateFilterData(url);
    }, 250)
  }

  componentDidMount() {
    this.updateFilterData();
  }

  async updateFilterData(dist_url) {
    if (!dist_url) { dist_url = window.location.href }

    const sign = dist_url.indexOf('?') == -1 ? '?' : '&'
    const url = `${dist_url.replace('loc', 'com').replace('http://', 'https://')}${sign}json=1`

    this.setState({
      loading: true
    });

    await fetch(url).then(d => d.json()).then(json_data => {
      
        const fields = json_data.filters_data.customFields || [];
        const deps = json_data.filters_data.dependencies || [];
        const params = new URL(url).searchParams;


        if (!this.init) {
          this.state.searchParams.forEach((value, key) => {
            params[key] = value
          });
        }

        this.setState({
          ...this.state,
          total_count: json_data.pagination.total_count || 0,
          filters_data: json_data.filters_data || [],
          categories: json_data.filters_data.categories || [],
          sub_category: json_data.filters_data.categories.length == 1 ? json_data.filters_data.categories[0].childs : [],
          cities: json_data.filters_data.cities || [],
          areas: json_data.filters_data.areas || [],
          customFields: [...fields, ...deps].flat(),
          field_value: {
            ...this.state.field_value,
            ...params,
          },
        })

        if (!this.init) {
          this.setState({
            ...this.state,
            field_value: {
              ...this.state.field_value,
              category_id: this.props.categoryId,
              sub_category_id: this.props.subCategoryId,
              city_id: this.getCityIDBySlug(this.props.citySlug, json_data.filters_data.cities || [])?.city_id,
              area_id: this.getAreaIDBySlug(this.props.areaSlug, json_data.filters_data.areas || [])?.id,
            }
          })
          this.init = true
        }

        this.updateSubmitButtonCount(json_data.pagination.total_count || 0)
      

      if (json_data.total_count == 0) {
        this.props.submitButton.setAttribute('disabled', 'disabled')
      } else {
        this.props.submitButton.removeAttribute('disabled')
      }

      if (this.state.field_value.sub_category_id == 44 || this.state.field_value.category_id == 44) {
        document.querySelector('#selectable-sorting').classList.add('hide')
        document.querySelector('#slider-price').classList.add('hide')
      } else {
        document.querySelector('#selectable-sorting').classList.remove('hide')
        document.querySelector('#slider-price').classList.remove('hide')
      }
    })

    this.setState({
      loading: false
    });
  }

  async onFieldChange(key, value) {
    let field_value = {
      ...this.state.field_value,
      [key]: value,
    }

    switch (key) {
      case 'category_id':
        delete field_value['sub_category_id']
        this.resetForm()
        break;
      case 'city_id':
        delete field_value['area_id']
        break;
    }

    await this.setState({ field_value })

    const _this = this;

    setTimeout(() => {
      const url = _this.buildUrl()
      _this.updateFilterData(url);
    }, 250)
  }

  getCategorySlugByID = (id) => {
    try {
      return this.state.categories.find(item => item.id == id)
    } catch (e) { }
    return '';
  }

  getSubCategorySlugByID = (id) => {
    try {
      return this.state.sub_category.find(item => item.id == id)
    } catch (e) { }
    return '';
  }

  getCityIDBySlug = (slug, data) => {
    try {
      return data.find(item => item.city_slug == slug);
    } catch (e) { }
    return ''
  }

  getAreaIDBySlug = (slug, data, key) => {
    try {
      return data.find(item => (item.slug == slug));
    } catch (e) { }
    return '';
  }

  getCitySlugByID = (id, data) => {
    try {
      return data.find(item => (item.city_id == id))
    } catch (e) { }
    return '';
  }

  getAreaSlugById = (id, data) => {
    try {
      return data.find(item => (item.id == id));
    } catch (e) { }
    return '';
  }

  buildUrl() {
    const { cities, areas, field_value, formReset } = this.state;
    const { category_id, sub_category_id, city_id, area_id } = field_value;

    let city = this.getCitySlugByID(Number(city_id), cities)
    let area = this.getAreaSlugById(Number(area_id), areas)
    let category = this.getCategorySlugByID(Number(category_id))
    let sub_category = this.getSubCategorySlugByID(Number(sub_category_id))

    let city_slug = city && city.city_slug
    let area_slug = area && area.slug
    let category_slug = category && category.category_slug
    let sub_category_slug = sub_category && sub_category.category_slug

    let segmentString = '';

    if (city && city_slug != '') { segmentString = `${segmentString}/${city_slug}` }
    if (area && area_slug != '') { segmentString = `${segmentString}/${area_slug}` }
    if (category && category_slug != '') { segmentString = `${segmentString}/${category_slug}` }
    if (sub_category && sub_category_slug != '') { segmentString = `${segmentString}/${sub_category_slug}` }
    segmentString = segmentString.replace('//', '/');

    const url = new URL(`${BASE.url}adverts/السودان${segmentString}`)

    if (!formReset) {
      Object.keys(field_value).forEach(key => {
        if (['category_id', 'sub_category_id', 'city_id', 'area_id'].includes(key)) { return; }
        if (field_value[key]) {
          url.searchParams.append(key, field_value[key]);
        }
      })
    }

    return url.toString();
  }

  handleClearValue = (key) => {
    const { field_value } = this.state;
    field_value[key] = undefined;

    this.setState({
      field_value,
    })

    const _this = this;

    const url = _this.buildUrl()
    window.history.pushState(null, '', url)

    setTimeout(() => {
      _this.updateFilterData(url);
    }, 250)
  }

  render() {
    const { categories, sub_category, cities, areas, customFields, field_value } = this.state;
    const { category_id, sub_category_id, city_id, area_id } = field_value;

    const category = this.getCategorySlugByID(category_id) || null
    const sub_cat = this.getSubCategorySlugByID(sub_category_id) || null
    const city = this.getCitySlugByID(city_id, cities) || null
    const area = this.getAreaSlugById(area_id, areas) || null

    const city_slug = city && city.city_slug;
    const area_slug = area && area.slug;
    const category_slug = category && category.category_slug;
    const sub_category_slug = sub_cat && sub_cat.category_slug;
    return (
      <div className={['CustomForm', this.state.loading ? 'loading' : ''].join(' ')}>
        <div className="field">
          <select disabled={categories.length == 1 && category_id} value={category_id} className="input select input-basic autocomplete-categories all-categories" onChange={ev => this.onFieldChange('category_id', ev.target.value)} data-slug={category_slug} name="category" placeholder="">
            {category_id ? '' : <option value="">{modalV4.category_filter}</option>}
            {categories.map(item => (
              <option key={item.id} value={item.id}>
                {item.category_name}
              </option>
            ))}
          </select>
          {category_id ?
            <span
              className="clear"
              onClick={e => {
                this.resetForm()
              }}
            >x</span>
            : null
          }
        </div>
        {sub_category ?
          <div className="field">
            <select disabled={sub_category.length == 1 && sub_category_id} value={sub_category_id} className={`input select input-basic ${this.state.active_cate} `} name="sub_category" data-slug={sub_category_slug} onChange={ev => this.onFieldChange('sub_category_id', ev.target.value)}>
              {sub_category_id ? '' : <option value="">{modalV4.sub_category_filter}</option>}
              {sub_category.map(_child => (
                <option key={_child.id} value={_child.id}>
                  {_child.category_name}
                </option>
              ))}
            </select>
            {sub_category_id && sub_category_id != category_id ?
              <span
                className="clear"
                onClick={() => {
                  this.onFieldChange('sub_category_id', '')
                  this.resetForm()
                }}
              >x</span>
              : null
            }
          </div>
          : null
        }
        <div className="field">
          <select disabled={cities.length == 1 && city_id} value={city_id} className="input select input-basic" data-slug={city_slug} name="city" placeholder="" onChange={ev => this.onFieldChange('city_id', ev.target.value)}>
            <option value="">{modalV4.city}</option>
            {cities.map(city => (
              <option key={city.city_id} value={city.city_id}>
                {city.city_name}
              </option>
            ))}
          </select>
          {city_id ?
            <span
              className="clear"
              onClick={() => {
                this.onFieldChange('city_id', '')
              }}
            >x</span>
            : null
          }
        </div>
        {areas.length != 0 ?
          <div className="field">
            <select disabled={areas.length == 1 && area_id} value={area_id} className={`input select input-basic ${this.state.active_city} `} data-slug={area_slug} onChange={ev => this.onFieldChange('area_id', ev.target.value)} name="area" placeholder="">
              <option value="">{modalV4.area}</option>
              {areas.map(area => (
                <option key={area.id} value={area.id}>
                  {area.name}
                </option>
              ))}
            </select>
            {area_id ?
              <span
                className="clear"
                onClick={() => {
                  this.onFieldChange('area_id', '')
                }}
              >x</span>
              : null
            }
          </div>
          : null
        }
        {customFields ? customFields.map((field) => this.renderCustomField(field)) : null}
      </div>
    );
  }

  renderCustomField(field) {
    let FieldDom = () => {
      switch (field.type) {
        case 'dropdown':
          return this.renderDropdownCustomField(field);
          break;
        case 'checklist':
          return this.renderChecklistCustomField(field);
          break;
        case 'text':
          // uncomment here if you want to enable custom fields of type "text"
          // return this.renderTextCustomField(field);
          break;
      }

      return null;
    };

    return (
      <React.Fragment key={field.name}>
        <FieldDom />
      </React.Fragment>
    )
  }

  checklistFieldChanged(input, field) {
    const { checked, value } = input;
    const defaultValue = this.state.field_value[field.name] || this.state.searchParams[field.name] || '';
    const list = defaultValue == '' ? [] : defaultValue.split('|');

    if (checked) {
      if (list.indexOf(value) < 0) {
        list.push(value);
      }
    } else {
      list.splice(list.indexOf(value), 1);
    }

    this.setState({
      field_value: {
        ...this.state.field_value,
        [field.name]: list.join('|')
      }
    });

    const _this = this;


    setTimeout(() => {
      const url = _this.buildUrl()
      _this.updateFilterData(url);
    }, 250)
  }

  renderChecklistCustomField(field) {
    let options = [];
    try {
      options = String(field.options).split('|')
    } catch (e) {
    }
    const defaultValue = this.state.field_value[field.name] || this.state.searchParams[field.name] || '';

    return (
      <div className="field-group">
        <b className="field-title">{field.display_name}</b>
        <input type="hidden" name={field.name} value={defaultValue} />
        {options.map(option => {
          let checked = defaultValue.indexOf(option) > -1;
          return (
            <label key={option} className="field-label">
              <input
                className="field-checkbox"
                type="checkbox"
                value={option}
                checked={checked}
                onChange={(ev) => this.checklistFieldChanged(ev.target, field)}
              />
              {option}
            </label>
          )
        })}
      </div>
    )
  }

  renderDropdownCustomField(field) {
    let options = String(field.options).split('|');
    const defaultValue = this.state.field_value[field.name] || this.state.searchParams[field.name] || '';

    return (
      <div className="field">
        <select disabled={options.length == 1 && defaultValue != ''} value={defaultValue} className={`input select input-basic ${this.state.active_subcat} `} name={field.name} onChange={ev => this.onFieldChange(field.name, ev.target.value)}>
          <option value="">
            {field.display_name}
          </option>
          {options.map(option => (
            <option value={option} key={option}>
              {option}
            </option>
          ))}
        </select>
        {defaultValue && defaultValue != '' ?
          <span
            className="clear"
            onClick={e => {
              this.onFieldChange(field.name, '')
            }}
          >x</span>
          : null
        }
      </div>
    )
  }

  renderTextCustomField(field) {
    const defaultValue = this.state.field_value[field.name] || this.state.searchParams[field.name] || '';

    return (
      <input
        defaultValue={defaultValue}
        className={`input input-basic ${this.state.active_subcat} `}
        name={field.name}
        placeholder={field.display_name}
        onBlur={ev => {
          this.onFieldChange(field.name, ev.target.value)
        }}
      />
    )
  }
}

const customFormRenderDom = document.getElementById("custom_form");

if (customFormRenderDom) {
  const customFormSubmitButtonDom = customFormRenderDom.parentElement.querySelector('.btn[type=submit]')
  const data = {
    categoryId: customFormRenderDom.getAttribute('data-cat'),
    subCategoryId: customFormRenderDom.getAttribute('data-sub_cat'),
    citySlug: customFormRenderDom.getAttribute('data-city'),
    areaSlug: customFormRenderDom.getAttribute('data-area')
  }
  ReactDOM.render(<CustomForm {...data} submitButton={customFormSubmitButtonDom} />, customFormRenderDom);
}